'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = undefined;

var _revalidate = require('revalidate');

var validate = exports.validate = (0, _revalidate.combineValidators)({
  name: (0, _revalidate.isRequired)({ message: 'This is who will be invoiced' }),
  postalCode: (0, _revalidate.isRequired)({ message: 'Postal code is required' }),
  city: (0, _revalidate.isRequired)({ message: 'City is required' }),
  country: (0, _revalidate.isRequired)({ message: 'Country is required' })
});


//////////////////
// WEBPACK FOOTER
// ./src/utils/addressSettingsFormValidation.js
// module id = 2543
// module chunks = 0